import React from 'react'
import { useRef, useEffect } from 'react'
import { useRouter } from 'next/router'
import { FormSpy } from "react-final-form"

/* AutoSave
 * will detect when a change in a field has happened
 * and saves when the field blurs
 *
 * @param {object} values: form state values
 *
 * @param {string || undefined} active: string of active field
 *  or undefined if no active field
 *
 * @param {function} save: save data function
*/
const Autosave = ({ values, active, save, debounce = 500, enabled = true }) => {
  const { query } = useRouter()
  const previousActive = useRef(active)
  const previousValues = useRef(values)

  const handleAutoSave = async () => {
    try {

      if (query?.origin) {
        values = { ...values, ['Event Source']: query.origin.split('-').join(' ') }
      }

      await save(values)
      previousValues.current = values
    } catch (err) {
      console.log(err)
    }
  }

  // handles checking if a field was blurred
  // will call handleAutoSave after debounce
  // debounce allows all dom updates to finis
  useEffect(() => {
    if (!enabled) {
      return
    }

    let timeout = null
    const hasChanged = JSON.stringify(previousValues?.current) !== JSON.stringify(values)

    // if the previous value is not the active value
    // trigger a save
    if (
      previousActive.current !== active &&
      hasChanged
    ) {
      timeout = setTimeout(handleAutoSave, debounce)
    }

    previousActive.current = active

    return () => {
      clearTimeout(timeout)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [active, enabled])

  return null
}


const AutoSaveSpy = (props) => (
  <FormSpy 
    {...props}
    render={Autosave}
    subscription={{ active: true, values: true }}
  />
)

export default AutoSaveSpy
